export default "__VITE_ASSET__TUJKbUVQ__"